import React from 'react';
 
import { Helmet } from 'react-helmet';
import { Briefcase, Code, Smartphone, TrendingUp, ArrowRight} from "lucide-react"; // example icons
import { SiSolid } from 'react-icons/si';

const TechnologyDevelopmentServices = () => {
  return (
    <section className="tech-services-section ">
      <Helmet>
        <title>Technology Development Services | Pravisht Digital</title>
        <meta
          name="description"
          content="Pravisht provides end-to-end technology development services including application development, consulting, automation, IoT, blockchain, and mobile apps to drive digital transformation."
        />
        <meta
          name="keywords"
          content="Technology Development, Application Development, Consulting Services, IoT, Blockchain, Automation, Mobile Apps, Digital Transformation, Pravisht"
        />
        <meta property="og:title" content="Technology Development Services | Pravisht Digital" />
        <meta
          property="og:description"
          content="End-to-end technology development solutions by Pravisht for scalable enterprise transformation."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/service_pravisht.jpg" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet>

       <div className="breadcrumb">
              {/* <a href="/">Home</a> &gt; <a href="#">Who We Are</a> &gt; <span>About Us</span> */}
               <a href="/">Home</a> &gt;  <span>Technology Development Services</span>
           </div>

        <div className="about-heading-section">
            <h1>Technology Development Services</h1>
            <p>
            At Pravisht, we specialise in end-to-end technology solutions that drive digital transformation across
industries. Our integrated approach combines application development, consulting, automation,
and platform engineering to help enterprises evolve, scale, and stay future-ready.
            </p>
        </div>
      <div className="about-image-fullscreen">
        <img src="/service_pravisht.jpg" alt="Pravisht Digital" />
        </div>

      <div className="core-offerings">
       <div className="how-we-help__content">
                    <p className="how-we-help__description services-desc">Our Services</p>
                    <h1  className="how-we-help__title"> Our Core Offering </h1><hr className="portfolio-horizontalline"></hr>
        </div>

        <div className="offerings-grid">
          {/* Offering 1: Application Development */}
          <div className="offering-card app-dev-card">
            <h4>1. Application Development</h4>
            <p>We build scalable, high-performance enterprise applications using the latest tech stacks:</p>
            <ul>
              <li>Java, .NET, ReactJS, NodeJS, AngularJS, MuleSoft, Dell Boomi, ServiceNow, Salesforce</li>
              <li>Portal and Web App Development</li>
              <li>Database Optimisation and Performance Tuning</li>
              <li>Full-stack engineering with modern architecture</li>
            </ul>
          </div>

          {/* Offering 2: Consulting Services */}
          <div className="offering-card consulting-card">
            <h4>2. Consulting Services</h4>
            <p>We guide organisations with strategic technology roadmaps and audit frameworks:</p>
            <ul>
              <li>Application Consulting &amp; Audit Services</li>
              <li>Business Solution Consulting</li>
              <li>Technology Feasibility &amp; Architecture Planning</li>
            </ul>
          </div>

          {/* Offering 3: IoT, Blockchain, Metaverse & DevOps */}
          <div className="offering-card iot-blockchain-card">
            <h4>3. IoT, Blockchain, Metaverse &amp; DevOps</h4>
            <p>Stay ahead with advanced technology integrations:</p>
            <ul>
              <li>DevOps &amp; DevSecOps Services</li>
              <li>Blockchain Development &amp; Metaverse Platforms</li>
              <li>IoT Platform Integration (AWS, Azure, and more)</li>
            </ul>
          </div>

          {/* Image next to cards - as seen in the screenshot */}
          {/* <div className="offering-image-right">
             <img
                src="https://via.placeholder.com/300x400/36454F/ffffff?text=Developer+Working" // Placeholder image URL
                alt="Developer working on a tablet"
                className="developer-image"
              />
          </div> */}

          {/* Offering 4: Automation Engineering */}
          <div className="offering-card automation-card">
            <h4>4. Automation Engineering</h4>
            <p>Enhance efficiency through automation and intelligence:</p>
            <ul>
              <li>Artificial Intelligence (AI) &amp; Machine Learning (ML)</li>
              <li>Robotic Process Automation (RPA)</li>
              <li>Augmented &amp; Virtual Reality (AR/VR) Integration</li>
            </ul>
          </div>

          {/* Offering 5: Enterprise Mobile Applications */}
          <div className="offering-card mobile-apps-card">
            <h4>5. Enterprise Mobile Applications</h4>
            <p>Deliver seamless mobile experiences across platforms:</p>
            <ul>
              <li>Android, iOS, Flutter, Kotlin, Xamarin, HTML5/JS</li>
              <li>Mobile Websites and Cross-Platform Apps</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="engagement-layers-and-why-choose" style={{backgroundColor:'#f1f4f3'}}>
        <h3 className="section-subtitle">Our Engagement Layers</h3>
        <p>We deliver across 4 strategic pillars to ensure complete digital transformation:</p>
        <div className="bottom-sections-grid">
          <div className="how-we-help__cards " >
                {[
                     { icon: <Briefcase size={40} />, title: "Development", desc: "Build from scratch with modern tools and technologies" },
                     { icon: <Code size={40} />, title: "Consulting", desc: "Align IT strategy with your business objectives" },
                    { icon: <Smartphone size={40} />, title: "Migration", desc: "Seamlessly move from legacy systems to modern platforms" },
                    { icon: <TrendingUp size={40} />, title: "Maintenance", desc: "Ensure continuous operations, updates, and optimisation" }
        
                ].map((card, i) => (
                <div className="how-we-help__card" key={i} style={{height:'190px',cursor:'default'}}>
                    {/* <div className="card-icon">{card.icon}</div> */}
                    <h3 className="card-title">{card.title}</h3>
                    <p className="card-desc">{card.desc}</p>
                </div>
                ))}
            </div>
          
        </div>
      </div>
    </section>
  );
};

export default TechnologyDevelopmentServices;